export const BRAND_NAME = "MIK EDUCATION";
export const BRAND_LOGO = "/images/brand_logo.webp";
export const SITE_URL = "https://learn.mik-education.com";
export const STORE_URL = "https://learn.mik-education.com/store";
export const CHECKOUT_URL =
  "https://learn.mik-education.com/web/checkout/68edfb645355bc964b65eeba";
export const OG_IMAGE =
  "https://tagmango.com/publicassets/-chatgpt-image-aug-29-2026-12_17_41-pm-9a1a8953957ede4e7f27f2149a97c705.png";

export const HERO_BADGES = ["Teacher's Day TIDWA Offer", "1st \u2013 7th September", "365 Day Access"];

export const PROMO_POSTER = {
  badge: "Teachers' Day TIDWA Offer",
  eyebrow: "Why Choose One?",
  headline: "Master Both.",
  courses: ["Porcelain Laminate Veneers", "Crown and Bridge Dentistry"],
  offer: "Buy One. Get One Free.",
  access: "365 Days Unlimited Access",
  bonusNote: "First 25 Buyers: Advanced Bur Kit Complimentary",
  dateRange: "1 \u2013 7 September",
};

export const SALE_DATES = "1st \u2013 7th September";

export const SALE_TAGLINE = "Some lessons don't just teach. They transform your practice.";

export const PRIMARY_HEADLINE = "Buy 1 \u2014 Get 3";

export const ROTATING_TAGLINES = [
  "Some Lessons Don't Just Teach. They Transform Your Practice.",
  "One Course Price. The Complete Prostho Workflow.",
  "Never Before. Never After. Pay for One. Get Three.",
  "Functional Bites Meet Stunning Smiles.",
];

export const HERO_SUBHEADLINE =
  "The Perfect Pairing: CnB Masterclass (strong basics) + PLV Masterclass (strong aesthetics and big money). Together, they give you the power to deliver functional bites and stunning smiles.";

export const SEATS_LEFT_TEXT = "First 25 Buyers Get the Advanced Bur Kit Complimentary";

export const TEACHERS_DAY_BANNER_CTA_NOTE = "Click the button to explore the offers.";

export const OFFER_CLARIFIER =
  "Buy One Masterclass, Get Another Absolutely Free + Complimentary Advanced Bur Kit.";

export const HERO_CLOSING_TAGLINE = "A Complete Restorative Journey.";

export const TEASER_CARD = {
  badge: "Teachers' Day Special",
  setupLine: "Ek Course Lene Aaye The...",
  punchLine: "3 Lekar Jaoge!",
  tags: ["PLV", "CNB", "BUR KIT"],
  offerBadge: "3-in-1 Offer",
  bullets: [
    "Porcelain Laminate Veneers & Smile Design",
    "Crown and Bridge Dentistry",
    "Advanced Bur Kit for the First 25 Buyers",
  ],
  stats: [
    { label: "365 Days", sub: "Unlimited Access" },
    { label: "1\u20137 September", sub: "Offer Window" },
  ],
  ctaLine: "Click Below for Details",
};

export const COURSES = [
  {
    id: "plv",
    index: "01",
    badge: "Course 1",
    name: "PLV Masterclass",
    fullName: "Porcelain Laminate Veneers",
    tagline: "Beautiful Smiles Start with a Strong Foundation",
    lines: ["The Aesthetics.", "The Big-Money Cases.", "The Complete PLV Course."],
    highlight: "Aesthetics \u2014 big-money cosmetic cases",
    description:
      "Learn the exact clinical sequence to plan, prep and deliver flawless porcelain laminate veneers \u2014 the cosmetic cases that command premium fees and build a referral-driven practice.",
    videos: "77 Videos",
    hours: "14 Hrs 12 Min",
    theme: "pink",
  },
  {
    id: "cnb",
    index: "02",
    badge: "Course 2",
    name: "CnB Masterclass",
    fullName: "Crown & Bridge \u2014 From Preparation to Cementation",
    tagline: "Master the Fundamentals. Build the Foundation.",
    lines: ["The Basics.", "The Function.", "The Complete CnB Course."],
    highlight: "Clinical basics \u2014 functional dentistry",
    description:
      "Build rock-solid fundamentals in crown and bridge prosthodontics \u2014 preparation design, occlusion and functional bites that every restorative case depends on.",
    videos: "10 Modules",
    hours: "20+ Hrs",
    theme: "blue",
  },
];

export const MENTOR = {
  name: "Prof. Dr. Moez Khakiani",
  experience: "18+ Years Experience",
  image: "/images/mentor.webp",
  bio: "Prof. Dr. Moez Khakiani maintains a private practice in Bandra, Mumbai \u2014 'Smile Masters and Jaw Joint Matters' since 2006, with special attention towards Fixed Prosthetics, Functional Smile Designing and Full Mouth Reconstructions.",
  credentials: [
    "Post Graduate Diploma in Esthetic and Cosmetic Dentistry, State University of Buffalo, NY, USA",
    "MDS in Prosthodontics",
    "Fellow of ICOI, PFA, ICD & TMD/Orofacial Pain (Roseman University, USA)",
    "Author of 'Clinical Fixed Prosthodontics: Starter and Master Volume'",
    "Founder Chairman, Academy of Digital Dentistry & Co-founder of MIK Dental",
    "KOL for 3M, Colgate, Abbott, Medicept, IPCA & Hu-Friedy",
  ],
};

export const BONUS_GIFT = {
  title: "Anterior Midline Point Stop Appliance",
  subtitle: "Complimentary Teacher's Day Gift",
  copy: "As part of this Teacher's Day Celebration, your first TMJ Splint comes complimentary from MIK Splint Lab.",
  image:
    "https://tagmango.com/staticassets/-compressed-image-e84d9f2ce620cf0e685190dfcddee0dc.webp",
  terms: [
    "Applies only to a hard or hard-soft splint with an anterior stop.",
    "Must be claimed on or before 31 March 2027.",
    "Only the splint is complimentary; any physical model requiring 3D printing is charged separately.",
    "Subject to clinical suitability and MIK TMJ Splint Lab protocol.",
  ],
};

export const WHY_BUNDLE_STATEMENTS = [
  "From Partial Coverage to Full Coverage \u2014 All in 1.",
  "Because E-max and Zirconia Don't Prep the Same.",
  "Aesthetics. Function. Execution. 3 at the Cost of 1.",
  "Teacher's Day Mathematics: One Course = Three Wins.",
];

export const LEARNING_OUTCOMES = [
  "Confident case selection for veneers and crowns",
  "Correct material selection (E-max vs Zirconia) and prep protocols",
  "Reduced remakes, fractures, and clinical failures",
  "Complete anterior-to-posterior fixed prosthodontics workflow",
  "Free precision Advanced Bur Kit (Gladiator Series) to execute what you learn",
];

export const PLV_CURRICULUM = [
  { section: "Section 1: Masterclass Kickoff", topics: ["Veneer Booklet for Download", "Introduction", "Looking Ahead"] },
  { section: "Section 2: Anatomy of Aesthetics", topics: ["Principles of Smile Design", "Spectrum of Smile Solutions"] },
  {
    section: "Section 3: Choices, Clarity & Comparisons",
    topics: [
      "Veneers vs. Full Coverage: Let's Compare",
      "What Is a Porcelain Laminate Veneer?",
      "Laminate vs. Veneer: Same or Different?",
      "Ceramic vs. Composite: Choosing the Right Material",
      "The Evolution of Prosthetic Materials",
      "LiDiSi vs. Zirconia: Let's Settle the Score",
    ],
  },
  {
    section: "Section 4: Green Lights & Red Flags",
    topics: [
      "Who's the Right Candidate? Indications for Veneers",
      "Cases You Shouldn't Veneer: Contraindications",
      "Ideal First Cases: Veneers for Beginners",
      "It's Not Always Linear",
    ],
  },
  { section: "Section 5: Substrate Science", topics: ["The Golden Rule of Prepping"] },
  {
    section: "Section 6: The Prep Playbook",
    topics: [
      "No-Prep Veneers: Hype vs. Reality",
      "The Five Veneer Preparation Designs",
      "Feather Incisal Edge: A Design You Can Skip",
      "A Look Inside the Window Preparation",
      "Labio-Incisal Preparation: The Gold Standard",
      "Labio-Incisal Preparation: A Closer Look",
      "Proximal Contacts: Should You Break Them?",
      "The Wrap-Around Preparation: Use with Caution",
      "Margins & Gingiva: Where to Draw the Line",
      "Illustrated Recap",
      "A Story Before We Go Further \u2014 with Dr. Jashan Arora",
    ],
  },
  { section: "Section 7: Bur Selection\u2014Simplified", topics: ["The Veneer Preparation Kit That Just Makes Sense"] },
  {
    section: "Section 8: Planning Before Prepping",
    topics: ["Index First, Prep Second\u2014Guided by Putty", "Making the Guide Before the Grind\u2014Video Demonstration"],
  },
  {
    section: "Section 9: Tooth Preparation\u2014A Visual Journey",
    topics: [
      "Veneer Preparation Explained: One Image at a Time",
      "Central Incisor Preparation\u2014Step-by-Step Video Demonstration",
      "Design Variations\u2014Lateral, Canine and Premolar Preparation",
      "Explore the MIK Library",
      "Diastema Cases\u2014The Slice Preparation Protocol",
    ],
  },
  {
    section: "Section 10: The Art of Tissue Retraction",
    topics: ["Why Retraction Isn't Optional", "Retraction with Cord\u2014The Classic Technique", "Frustrated with Cords? Try This"],
  },
  { section: "Section 11: Impression Edition\u2014Your Lab Communication", topics: ["Impression Materials & Techniques\u2014What Really Works"] },
  { section: "Section 12: The Provisional Protocol", topics: ["Provisionalisation\u2014Materials, Method & Demonstration"] },
  {
    section: "Section 13: Lab Communication with LiDiSi",
    topics: ["Pressed or Milled\u2014Which Works Better?", "Discoloured Teeth\u2014How to Communicate the Shade"],
  },
  {
    section: "Section 14: Because Bonding Matters",
    topics: ["What Affects Veneer Bonding? Part 1: The Cement Matters", "What Affects Veneer Bonding? Part 2: The Substrate Matters"],
  },
  {
    section: "Section 15: The Bonding Protocol\u2014Seal the Deal",
    topics: [
      "Preparing the Prosthesis: The Indian Marriage Analogy",
      "Preparing the Tooth for Bonding",
      "Bonding with Light-Cure Resin Cement",
      "When It Doesn't Go Right\u2014Don't Quit",
      "A Story with a Lesson",
      "Bonding Composite vs. Porcelain: What's the Real Difference?",
    ],
  },
  {
    section: "Section 16: The Veneer Workflow",
    topics: ["From Consultation to Cementation", "Additive vs. Reductive: Veneer Case Types Explained"],
  },
  {
    section: "Section 17: Time for Real Cases",
    topics: [
      "Case: Two Simple Laminates\u2014One Massive Transformation",
      "Case: Four Incisors, Part 1\u2014Design Before Drill: Planning Four Incisors",
      "Case: Four Incisors, Part 2\u2014Provisionals and Trial",
      "Case: Four Incisors, Part 3\u2014Bonding in Action",
      "Case: 12-Unit Smile Design Using the Additive Contour Philosophy",
      "Knowledge Is Power\u2014Only When It Is Applied, with Dr. Jashan Arora",
      "Pop Quiz",
      "Case: Peg Laterals\u2014Preparation to Bonding",
      "Case: Two Centrals\u2014Analog vs. Digital: My Verdict",
      "Case: Four Incisors\u2014Slice and Window: A Smart Mix",
      "Case: Social Six\u2014The Smile Puzzle",
      "Case: Closing Black Triangles",
      "Case: Six Laminates\u2014Management of Anterior Crowding",
      "Case: Fractured Centrals, Part 1\u2014The Foundation",
      "Case: Fractured Centrals, Part 2\u2014Bonding in Action",
      "Case: When Composite Fails\u2014Try Chip Ceramic",
      "Case: Two Centrals\u2014Reductive Test Drive in Action",
      "Case: 19 Restorations\u2014Where Art Meets Occlusion",
      "Case: FMR\u2014Restoring Erosion with Veneers and Overlays",
    ],
  },
  {
    section: "Section 18: The Hidden Art of Occlusion",
    topics: [
      "The Occlusion Anchors: Centrals & Canines",
      "Occlusal Equilibration in Action",
      "Case: 28 Units\u2014Veneers, Tabletops and Occlusion",
      "Learn How to Convince Patients for Porcelain Veneers",
    ],
  },
  {
    section: "Section 19: Failures\u2014Learning from What Went Wrong",
    topics: ["Why Veneers Fail and How to Prevent It\u2014Part 1", "Why Veneers Fail and How to Prevent It\u2014Part 2"],
  },
  { section: "Section 20: Thank You!", topics: ["Dhanyawad!"] },
];

export const CNB_CURRICULUM = [
  { section: "Section 1: Let's Start with the Course Manual", topics: ["Download and Print Manual"] },
  {
    section: "Section 2: Material Selection",
    topics: [
      "Rock, Paper, Scissor",
      "How Porcelain Grew Muscles",
      "Where Most Dentists Go Wrong",
      "The OG of Fixed Prosthodontics: Metal Crowns & Bridges",
      "When Metal Met Porcelain: PFM",
      "Half Metal. Half Porcelain. All Purpose: PFM Facing",
      "Zirconia 1: Not All Are Created Equal",
      "Zirconia 2: Built Different",
      "Zirconia 3: Not Without Its Flaws",
      "Zirconia Polishing Kit",
      "Zirconia 4: Layered. Cutback. Monolithic.",
      "The Lithium Disilicate Story",
      "The Most Important Lecture of This Section",
      "The Big Q&A: Material Selection Made Clear",
    ],
  },
  {
    section: "Section 3: The Language of Shade",
    topics: [
      "How We See Color",
      "The Anatomy of Color",
      "Why Dentists Struggle with Shade",
      "Vita Classic\u2014The Shade Guide We All Grew Up With",
      "Vita 3D-Master: The Honest Truth",
      "The Shade Guide I Trust and Why",
      "The Eight Rules of Shade Selection",
      "My Six Go-To Tips for Shade Selection",
      "The Flawed Side of Shade Guides",
      "Why Stump Shade Matters",
      "When the Machine Picks the Shade",
      "How to Talk Shade with Your Lab: The Four Tools",
      "The Final Word on Shade\u2014for Now",
    ],
  },
  {
    section: "Section 4: The Occlusion Code",
    topics: [
      "How Bad Can a High Point Be?",
      "Interference, Sensitivity and Flat Foot: The Connection",
      "Static Occlusion\u2014The Starting Point",
      "The Dynamics of Occlusion",
      "Mutually Protected Occlusion\u2014Still the Smartest Scheme",
      "Articulating Paper\u2014The Unsung Hero of Occlusion",
      "Occlusion + Shade\u2014Real Questions, Real Answers",
    ],
  },
  {
    section: "Section 5: Tooth Preparation Unlocked",
    topics: [
      "Tooth Preparation: A Game of Balance",
      "The Pregnant Crown Problem",
      "The Art of Margins: PFM vs. Metal-Free",
      "Tooth Reduction\u2014Not Too Much, Not Too Little",
      "The PFM Lingual Metal Collar\u2014More Than Meets the Eye",
      "No More Guesswork\u2014A Tool to Gauge Your Preparation",
      "Occlusal Reduction\u2014Anatomy Matters",
      "Root Anatomy: The Guide Beneath the Crown",
      "Protecting the Neighbor\u2014No Nicks, No Scratches",
      "The Science of Staying Put\u2014Preventing De-cementation",
      "You Have Been Doing Grooves All Wrong!",
      "Short Clinical Crowns\u2014The Pre-Impression Game Plan",
      "Explore the MIK Library",
      "Managing Short Crowns, Part 2\u2014After the Impression",
      "When Access Gets Tricky\u2014Distal of 7",
      "Can You Leave a Margin on Composite? The Verdict",
      "Bridge Preparations\u2014Same Game, Different Rules",
      "All About Pontics",
      "Margins and Burs for Anterior Teeth",
      "How Much to Prepare\u2014Anterior Teeth",
      "How to Prevent Pulpal Exposure",
      "Black Triangles Begone\u2014A Restorative Approach",
      "Sub, Equi or Supra? Margin Placement Rules",
      "Finish What You Start",
      "Sensitivity After Preparation\u2014What to Do",
      "Cases\u2014How to Think, Plan and Execute",
    ],
  },
  {
    section: "Section 6: Step-by-Step Crown Preparation Demonstrations",
    topics: [
      "Recommended Reductions",
      "Video Demonstration: Upper Central for Zirconia/e.max Crown\u201411",
      "Video Demonstration: Upper Canine for Zirconia/e.max Crown\u201413",
      "Video Demonstration: Lower Molar for PFM Crown\u201446",
      "Video Demonstration: Upper Molar for Monolithic Zirconia/Full Metal Crown\u201416",
      "Video Demonstration: Lower Incisor for Monolithic Zirconia\u201442",
      "Video Demonstration: Bridge Preparation for PFM\u201444",
      "Q&A\u2014Everything Tooth Preparation",
    ],
  },
  {
    section: "Section 7: Impressions That Impress",
    topics: [
      "Why Accuracy in Impressions Matters",
      "The \u201cWhy\u201d Behind Tissue Retraction",
      "Choosing the Right Cord and Packer",
      "The MIK Cord Packer",
      "Why Dentists Give Up on Cords",
      "The Classic Single-Cord Technique",
      "The Power of the Double-Cord Technique",
      "Single or Double Cord? The Decision Guide",
      "How Long Should a Cord Stay in the Sulcus?",
      "Hemostasis\u2014Why and How",
      "Cordless Retraction Explained",
      "Retraction Techniques\u2014A Quick Recap",
    ],
  },
  {
    section: "Section 8: Impression Materials and Techniques",
    topics: [
      "Impression Materials\u2014The Big Showdown",
      "Addition Silicone\u2014One-Step Technique",
      "Addition Silicone\u2014Two-Step Technique",
      "Hybrid Impression Technique\u2014My Go-To Technique",
      "Putty Mixing\u2014Eight Rules You Should Never Break",
      "Static Mixing Tips\u2014A Stunning Fact",
      "Choosing the Correct Impression Tray",
      "Alginate Impressions\u2014with a Twist",
    ],
  },
  {
    section: "Section 9: Mastering Bite Registration",
    topics: ["Bite Registration Materials\u2014What Works and What Does Not", "Do You Really Need a Bite Registration for Every Case?"],
  },
  {
    section: "Section 10: Provisional Restorations\u2014The Unsung Heroes",
    topics: [
      "Are Provisionals a Waste of Time, Effort and Money?",
      "Should Provisionals Be Made in the Lab or Chairside?",
      "Choosing the Right Provisional Material",
      "Typodont Demonstration: Bis-Acryl Resin Done Right",
      "Do All Provisionals Stain?",
      "Provisional Bridge Fabrication & Gingival Contouring",
      "Use of Resin Sticks",
      "Cementation & Retrieval of Provisionals",
      "Q&A\u2014From Impressions to Provisionals",
    ],
  },
  {
    section: "Section 11: Coping Trial",
    topics: [
      "Step-by-Step Lab Workflow",
      "Clinical Checklist Prior to the Patient Appointment",
      "Clinical Evaluation in the Mouth",
      "The Concept of Anatomic Coping",
      "The Concept of Reduction Coping",
    ],
  },
  {
    section: "Section 12: Bisque Trial",
    topics: [
      "Clinical Checklist Prior to the Patient Appointment",
      "Clinical Evaluation in the Mouth",
      "Articulating Paper and Steps in Bite Adjustment",
      "Management of Open Contact",
      "Identifying Interferences and Adjusting the Bite",
      "Excursive Occlusal Decisions",
      "Bad Dot Hunting",
      "When to Splint Crowns",
      "Ten Reasons for Food Lodgement After Cementation",
    ],
  },
  {
    section: "Section 13: Crowning Moment",
    topics: [
      "Cementation\u2014GIC & RMGIC",
      "Cementation\u2014Resin Cements and Protocol for Use",
      "Why Film Thickness Matters",
      "Zirconia Cementation Protocol",
      "Pre-Cementation Steps",
      "Air Abrasion Units",
      "Do's and Don'ts",
      "Explore the MIK Library",
    ],
  },
  { section: "Section 14: Ergonomics", topics: ["Why Dentists Suffer from Neck and Back Pain\u2014and How to Prevent It"] },
  {
    section: "Section 15: Retrieval of Permanently Cemented Crowns",
    topics: ["Failure of Cementation", "Retrieval\u2014Conservative Techniques", "WamKey and Christensen Crown Remover"],
  },
];

export const BUR_KIT_IMAGE = "/images/burkit.webp";

export const WORKFLOW_HEADING = {
  eyebrow: "Two Masterclasses. One Price.",
  heading: "The Complete Prostho Workflow",
};

export const BUR_KIT = {
  eyebrow: "Complimentary Gift",
  heading: "Advanced Bur Kit \u2014 On Us",
  copy: "The Gladiator Series Advanced Bur Kit for Crown, Bridge & Veneer preparation comes complimentary and free when you're among the first 25 buyers.",
  points: [
    "Complete Crown, Bridge & Veneer preparation kit",
    "Gladiator Series precision burs by Dr. Moez Khakiani",
    "Free only for the first 25 buyers \u2014 dispatched with your order",
    "Matches every technique taught across both masterclasses",
  ],
};

export const CERTIFICATE = {
  eyebrow: "Get Certified",
  heading: "Your Proof of Mastery",
  copy: "Complete both the PLV Masterclass and the CnB Masterclass to earn your MIK Education Certificate of Completion.",
  points: [
    "Awarded on completing both masterclasses \u2014 30+ hours of clinical training",
    "Signed by Prof. Dr. Moez Khakiani, Director \u2014 MIK Education",
    "Add credibility to your clinic wall and patient trust",
    "Share your achievement on LinkedIn and Instagram",
  ],
  image: "/images/certificate.webp",
};

export const FLEXIPAY = {
  eyebrow: "Flexible Payment Options",
  heading: "Split Your Payment. Keep Your Access.",
  image: "/images/flexipay.webp",
};

export const SOCIAL_PROOF = {
  badge: "600+ Five-Star Reviews",
  stats: [
    { value: "1,00,000+", label: "Dentists Trained in 12 Years" },
    { value: "600+", label: "Five-Star Reviews" },
    { value: "34+", label: "Hours of Combined Content" },
  ],
};

export const ACCESS_DURATION = "365-Day Access";

export const DUAL_PERSPECTIVE = [
  { label: "THE SMILE", course: "PLV Masterclass", accent: "teal" },
  { label: "THE BITE", course: "CnB Masterclass", accent: "gold" },
];

export const FAQ_ITEMS = [
  {
    question: "Why are PLV and CnB bundled together?",
    answer:
      "Because they are clinically linked. CnB teaches you the functional basics of restorative dentistry, while PLV builds the aesthetic layer on top of it. Bundled together, they complete the system \u2014 so you can deliver functional bites and stunning smiles from the same clinical foundation.",
  },
  {
    question: "Is this bundle suitable for beginners?",
    answer:
      "Yes \u2014 provided you are serious. Concepts are taught from fundamentals to advanced application, with clear protocols and clinical reasoning. No prior CnB or PLV expertise is required, just commitment.",
  },
  {
    question: "Are these full courses or abridged versions?",
    answer:
      "These are the complete, in-depth masterclasses. Nothing is removed \u2014 you get the entire curriculum of both programs, exactly like the offline batch.",
  },
  {
    question: "Will I receive certificates?",
    answer:
      "Yes, you receive a Certificate of Completion after finishing both the PLV Masterclass and the CnB Masterclass.",
  },
  {
    question: "What if I've already done a basic veneers or crown course?",
    answer:
      "If previous courses left you thinking \u201cI know a lot, but I'm not sure what to do,\u201d this bundle bridges that gap. It is about thinking like a clinician \u2014 not just mugging up routines.",
  },
  {
    question: "How do I claim the free Advanced Bur Kit offer?",
    answer:
      "The Advanced Bur Kit (Gladiator Series) is complimentary for the first 25 buyers only. It is dispatched automatically once your purchase is confirmed, while stock for the first 25 lasts.",
  },
];

export const COUNTDOWN_DEADLINE_ISO = "2026-09-07T23:59:59+05:30";

export const WHAT_YOU_GET = [
  {
    index: "01",
    title: "365-Day Access",
    description: "Learn at your own pace and revisit any lesson anytime, all year round.",
  },
  {
    index: "02",
    title: "Clinical Protocols",
    description: "Step-by-step clinical protocols, practical tips, and real case demonstrations.",
  },
  {
    index: "03",
    title: "Premium Learning",
    description: "Structured, evidence-based learning trusted by clinicians worldwide.",
  },
  {
    index: "04",
    title: "Advanced Bur Kit (Gladiator Series)",
    description: "First 25 buyers receive the complete Gladiator Series bur kit complimentary.",
  },
  {
    index: "05",
    title: "Certificate of Completion",
    description: "Earn your certificate on finishing both masterclasses.",
  },
];

export const MARQUEE_ITEMS = [
  "Pre-Recorded Masterclass",
  "Evidence-Based Protocols",
  "Clinical Excellence",
  "Teacher's Day Offer",
  "365-Day Access",
  "Certificate Included",
];
